/* RSI v2 · OmOss – logikk fra Claude Design. Krever rsi-dc.js. */

class RSIP_omoss extends DCLogic {
  renderVals() {
    return {};
  }
}

window.RSIP_omoss = RSIP_omoss;
